import React from 'react';
import Icon from '../../../components/AppIcon';

const WorkModeSelection = ({ selectedModes, onModeToggle }) => {
  const workModes = [
    {
      id: 'onsite',
      label: 'On-site',
      description: 'Work from office location',
      icon: 'Building2'
    },
    {
      id: 'hybrid',
      label: 'Hybrid',
      description: 'Mix of office and remote',
      icon: 'Laptop'
    },
    {
      id: 'remote',
      label: 'Remote',
      description: 'Work from anywhere',
      icon: 'Home'
    }
  ];

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        Work Mode Preferences
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        Select all work modes you're open to (multiple selections allowed)
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {workModes?.map((mode) => {
          const isSelected = selectedModes?.includes(mode?.id);
          
          return (
            <button
              key={mode?.id}
              onClick={() => onModeToggle(mode?.id)}
              className={`w-full min-w-0 p-6 md:p-8 rounded-2xl border-2 transition-all duration-250 text-left ${
                isSelected
                  ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
              }`}
            >
              <div className="flex items-start gap-4">
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${
                    isSelected
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground'
                  }`}
                >
                  <Icon name={mode?.icon} size={24} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                    {mode?.label}
                  </h3>
                  <p className="text-sm md:text-base text-muted-foreground">
                    {mode?.description}
                  </p>
                </div>
                {isSelected && (
                  <Icon name="Check" size={20} color="var(--color-primary)" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WorkModeSelection;